import { JSX } from 'react'

import { IconProps } from '../../icon'

const Next: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M40.9015 23.6738C40.8359 23.5262 40.7538 23.3949 40.639 23.28L35.7159 18.3569C35.24 17.881 34.4523 17.881 33.9764 18.3569C33.5005 18.8328 33.5005 19.6205 33.9764 20.0964L36.799 22.919H10.2308C9.55795 22.919 9 23.4769 9 24.1497C9 24.8226 9.55795 25.3805 10.2308 25.3805H36.799L33.9764 28.2031C33.5005 28.679 33.5005 29.4667 33.9764 29.9426C34.2226 30.1887 34.5344 30.3036 34.8462 30.3036C35.1579 30.3036 35.4697 30.1887 35.7159 29.9426L40.639 25.0195C40.7538 24.9046 40.8359 24.7733 40.9015 24.6256C41.0328 24.3303 41.0328 23.9856 40.9015 23.6903V23.6738Z'
      fill='black'
    />
  </svg>
)

export default Next
